<template>
  <div>
    <datatable
      :show_delete="false"
      :show_load_ghana_flags_button="true"
      :operations="operations"
      title="Company Positions"
      @thFilter="thFilter"
      @create="createPosition"
      @edit_click="editClick"
      @edit_hover="editHover"
      @edit_leave="editLeave"
      @related_positions_manager="showConnectedPositionManager"
      @duplicate_position="duplicatePosition"
      @ai_work_position="aiWorkPosition"
      @internal_notes="clickedInternalNotes"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :response="data"
      :working_th_searches="[]"
    ></datatable>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-positions',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      filters_helper,
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'position_title',
          value: 'title',
          component: 'LinkEntity',
          additional_data: {
            resource_type: 'Position'
          }
        },
        {
          name: 'message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/positions/',
            headers: 'admin_headers',
            resource_type: 'Position'
          }
        },
        {
          name: 'skills',
          value: 'positions_skills',
          component: 'DisplaySkills'
        },
        {
          name: 'offers',
          value: 'offers',
          component: 'GhanaFlag',
          additional_data: { resource_type: 'Position' }
        },
        {
          name: 'status',
          value: 'status',
          component: 'PositionStatus'
        },
        {
          name: 'company_position_id',
          value: 'company_position_id',
          component: 'TableCellEditableInput',
          additional_data: {
            field: 'company_position_id',
            id: 'position_id',
            function: 'updatePosition',
            resoutceId: 'id'
          }
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'company_id',
          value: 'company_id'
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        }
      ],
      data: [],
      filters: [
        {
          type: 'single',
          designator: 'statuses',
          options: [
            {
              text: 'active',
              value: 'active'
            },
            {
              text: 'standby',
              value: 'standby'
            },
            {
              text: 'blocked',
              value: 'blocked'
            },
            {
              text: 'editing',
              value: 'editing'
            },
            {
              text: 'expired',
              value: 'expired'
            },
            {
              text: 'fulfilled',
              value: 'fulfilled'
            },
            {
              text: 'deleted',
              value: 'deleted'
            },
            {
              text: 'test',
              value: 'test'
            }
          ]
        },
        {
          type: 'single',
          designator: 'is_hot',
          options: [
            {
              text: 'true',
              value: true
            },
            {
              text: 'false',
              value: false
            }
          ]
        },
        {
          type: 'single',
          designator: 'parent_env',
          options: filters_helper.getParentEnvFilterOptions()
        },
        {
          type: 'single',
          designator: 'abandoned_positions',
          options: [
            {
              text: 'true',
              value: true
            }
          ]
        }
      ],
      sorters: [
        {
          designator: 'id',
          value: '-id'
        },
        {
          designator: 'is_hot',
          value: '-is_hot'
        },
        {
          designator: 'status',
          value: 'status'
        }
      ],
      operations: [
        {
          component: 'CompletenessIndicator',
          additional_data: { resource_type: 'Position', api_path: '/positions/' }
        },
        {
          component: 'Preview',
          additional_data: { resource_type: 'Position' }
        },
        {
          component: 'AlertButton',
          additional_data: { resource_type: 'Position' }
        },
        { name: 'related_positions_manager', icon: '/group.svg' },
        { component: 'IsHot' },
        { name: 'duplicate_position', icon: '/duplicate.svg' },
        { name: 'ai_work_position', title: 'AI Work' },
        { name: 'internal_notes', icon: '/note.png' }
      ],
      th_filters: []
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    ...mapGetters('modals', ['findModal'])
  },
  methods: {
    init () {
      this.getPositions()
    },
    getPositions () {
      this.$network_utils
        .getCompanyPositions({
          current_company_id: this.$route.query.company_id,
          position_id: this.$route.query.show_id,
          sort: this.$route.query.sort,
          ...this.filters_helper.getServerCallFilters(this.filters),
          ...this.th_filters
        })
        .then(response => {
          this.data = Array.isArray(response) ? response : [response]
        })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getPositions()
    },
    showConnectedPositionManager (data) {
      this.create({ designator: 'connected-position-manager-modal', component_name: 'ConnectedPositionManager', position: data, modal_title: data.title + ' - Connected Position Manager', is_center_modal: true, modal_width: 1400 })
    },
    createPosition () {
      this.create({
        designator: 'create-position-step-one',
        component_name: 'CreatePositionStepOne',
        ignore_escape_button: true,
        company_id: this.$route.query.company_id,
        modal_title: 'Create Position'
      })
    },
    duplicatePosition (data) {
      this.create({
        designator: 'duplicate-position-form-modal',
        component_name: 'DuplicatePosition',
        data,
        modal_title: 'Duplicate Position - ' + data.title
      })
    },
    aiWorkPosition (data) {
      if (!confirm('תן ל-AI לעבוד על המשרה "' + data.title + '"?')) return
      this.$network_utils
        .aiWorkPosition({ position_id: data.id })
        .then(() => alert('הסוכן הופעל על המשרה'))
        .catch(err => alert('שגיאה בהפעלת הסוכן: ' + (err && err.message ? err.message : err)))
    },
    editHover (data) {
      this.create({ designator: 'position-info-modal', component_name: 'ModalPosition', modal_width: 1500, data: data, modal_title: 'Position: ' + data.title + ', Company: ' + data.company.name })
    },
    editLeave () {
      let position_info_modal = this.findModal({ type: 'designator', value: 'position-info-modal' })
      this.remove(position_info_modal)
    },
    editClick (data) {
      this.create({ designator: 'position-form-modal', component_name: 'PositionForm', data, modal_title: data.title })
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Position', resource_id: data.id, modal_title: data.title + ' הערות פנימיות' })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
